module.exports = __webpack_public_path__ + "img/opening-day.52d4b85f.svg";